import React from 'react';
import { Box, Grid } from '@mui/material';

import { OptionSwitch } from './option-switch';
import { OptionCheckbox } from './option-checkbox';

interface OptionProps {
  title: string;
  subtitle: string;
  checked: boolean;
  email: boolean;
  sms: boolean;
  onOption: () => void;
  onChannel: (props: { channel: 'email' | 'sms' }) => void;
}

export const Option = ({ title, subtitle, checked, email, sms, onOption, onChannel }: OptionProps) => {
  return (
    <>
      <Box
        sx={{
          marginRight: -8,
        }}
      >
        <OptionSwitch title={title} subtitle={subtitle} checked={checked} onClick={onOption} />
      </Box>

      <Box
        sx={{
          paddingLeft: 8,
          marginTop: 1,
        }}
      >
        <Grid container columnSpacing={4}>
          {/* TODO: It's not supported yet
          <Grid item xs={4}>
            <OptionCheckbox title="Platform" />
          </Grid> */}
          <Grid item xs={4}>
            <OptionCheckbox title="Email" checked={email} onClick={() => onChannel({ channel: 'email' })} />
          </Grid>
          <Grid item xs={4}>
            <OptionCheckbox title="SMS" checked={sms} onClick={() => onChannel({ channel: 'sms' })} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
